import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet
} from 'react-router-dom';

import { EstructuraProvider } from './context/EstructuraContext.jsx';

import Login         from './screens/Login.jsx';
import Home          from './screens/Home.jsx';
import Sector        from './screens/Sector.jsx';
import Valvula       from './screens/Valvula.jsx';
import Programacion  from './screens/Programacion/Programacion.jsx';
import Configuracion from './screens/Configuracion.jsx';

import MantenedorCampo   from './screens/Mantenedor/MantenedorCampo.jsx';
import MantenedorModulo  from './screens/Mantenedor/MantenedorModulo.jsx';
import MantenedorSector  from './screens/Mantenedor/MantenedorSector.jsx';
import MantenedorValvula from './screens/Mantenedor/MantenedorValvula.jsx';

import NavMenu    from './screens/components/NavMenu.jsx';
import Header     from './screens/components/Header.jsx';
import RelojChile from './screens/components/RelojChile.jsx';
import Footer     from './screens/components/Footer.jsx';

function MainLayout() {
  return (
    <div className="flex min-h-screen">
      <NavMenu />

      <div className="flex-1 flex flex-col">
        <Header />
        <RelojChile />
        <div className="flex-1 overflow-auto">
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default function App() {
  return (
    <EstructuraProvider>
      <Router>
        <Routes>
          {/* Ruta pública */}
          <Route path="/" element={<Login />} />

          {/* Rutas autenticadas */}
          <Route path="/*" element={<MainLayout />}>              
            {/* Páginas principales */}
            <Route path="home"                   element={<Home />} />
            <Route path="sector/:equipoId"       element={<Sector />} />
            <Route path="valvula/:sectorId"      element={<Valvula />} />
            <Route path="programacion/:moduloId" element={<Programacion />} />
            <Route path="configuracion"          element={<Configuracion />} />

            {/* Rutas independientes por mantenedor */}
            <Route path="mantenedormodulos"   element={<MantenedorModulo />} />
            <Route path="mantenedorsectores"  element={<MantenedorSector />} />
            <Route path="mantenedorvalvulas"  element={<MantenedorValvula />} />

            {/* Mantenedor con pestañas (opcional) */}
            <Route path="mantenedor" element={<MantenedorCampo />}>              
              <Route index                element={<Navigate to="modulos" replace />} />
              <Route path="modulos"      element={<MantenedorModulo />} />
              <Route path="sectores"     element={<MantenedorSector />} />
              <Route path="valvulas"     element={<MantenedorValvula />} />
            </Route>

            {/* Cualquier otra ruta */}
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Route>
        </Routes>
      </Router>
    </EstructuraProvider>
  );
}
